import { FormBuilder, FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { UserServiceService } from "../services/user-service/user-service.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { ReservationService } from "../services/reservation-service/reservation.service";

@Component({
  selector: "app-developer-wallet",
  templateUrl: "./developer-wallet.component.html",
  styleUrls: ["./developer-wallet.component.css"],
})
export class DeveloperWalletComponent implements OnInit {
  selectedWallet: any = {};
  filter_expand = false;
  filterForm: FormGroup;
  wallet: any;
  brokers: any = [];
  searchedBrokers: any = [];
  projects: any = [];
  userData: any = JSON.parse(window.localStorage.getItem("userProfile")) || {};
  check_all = false;
  page = 1;
  page_length = 15;
  lg: any = "lg";

  constructor(
    private userService: UserServiceService,
    private errorHandlerService: ErrorHandlerService,
    private formBuilder: FormBuilder,
    private slimLoadingService: SlimLoadingBarService,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.createForm();
    this.getBrokers();
    this.getProjects();
    this.getWallet();
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      from: [""],
      to: [""],
      project_ids: [[]],
      commissioned_for: [null],
      from_collect: [""],
      to_collect: [""],
      reservation_id: [""],
      unit_serial: [""],
      is_collect: [""],
      is_approve: [""],
    });
  }

  getWallet() {
    const payload = {
      ...this.filterForm.value,
      page: this.page,
      page_length: this.page_length,
    };
    this.slimLoadingService.start();
    this.userService.getDeveloperWallet(payload).subscribe(
      (res: any) => {
        this.wallet = res;
        this.check_all = false;
        this.slimLoadingService.complete();
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  getBrokers() {
    this.userService.getBrokersWallets().subscribe(
      (res: any) => {
        this.brokers = res || [];
        this.searchedBrokers = res || [];
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (data: any) => (this.projects = data || []),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  searchBrokers(search) {
    this.searchedBrokers = this.brokers.filter((broker) =>
      (broker.name || "").toLowerCase().includes((search || "").toLowerCase())
    );
  }

  changePageLength(pageLength) {
    this.page_length = pageLength;
    this.page = 1;
    this.getWallet();
  }

  pageChange(page) {
    this.page = page;
    this.getWallet();
  }

  resetFilter() {
    this.createForm();
    this.page = 1;
    this.page_length = 15;
    this.getWallet();
  }

  exportWallet() {
    this.userService.exportDeveloperWallet(this.filterForm.value).subscribe(
      (res: any) => window.open(res.url),
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  deleteCommission(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this commission!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingService.start();
        this.userService.deleteCommission(id).subscribe(
          () => {
            this.getWallet();
            swal("success", "Deleted commission successfully!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingService.complete();
          }
        );
      }
    });
  }

  approveWallet(id) {
    this.approveWalletIds([id]);
  }

  approveWalletSelected() {
    const selectedWallets = ((this.wallet || {}).wallets || { data: [] }).data.filter(
      (list) => list.checked
    );
    if (!selectedWallets.length) {
      swal("warning", "There is no selected wallet");
      return;
    }
    this.approveWalletIds(selectedWallets.map((doc) => doc.id));
  }

  approveWalletIds(ids) {
    swal({
      title: "Are you sure?",
      text: "You will approve!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingService.start();
        this.userService.approveWallet({ ids }).subscribe(
          () => {
            swal("Success", "approved successfully", "success");
            this.slimLoadingService.complete();
            this.getWallet();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingService.complete();
          }
        );
      }
    });
  }

  changeCommissionValue(modal) {
    const payload = {
      wallet_id: this.selectedWallet.id,
      commission: this.selectedWallet.commission,
    };
    this.slimLoadingService.start();
    this.userService.editCommission(payload).subscribe(
      () => {
        modal.close();
        this.slimLoadingService.complete();
        this.getWallet();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingService.complete();
      }
    );
  }

  onCheckAllToggle(event) {
    if (this.wallet && this.wallet.wallets) {
      this.check_all = event;
      this.wallet.wallets.data.forEach((e) => (e.checked = this.check_all));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/developer-wallet/developer-wallet.component.ts